import { filter } from "../typescript/interfaces";

export const OPTIONS_TOP_SEARCHES = {
  "Specialty (Self-Administered)": { section: "otherAttributes", keyword: "Specialty (Self-Administered)" },
  "Specialty (Professionally Administered)": {
    section: "otherAttributes",
    keyword: "Specialty (Professionally Administered)",
  },
  "Rare Disease": { section: "otherAttributes", keyword: "Rare Disease" },
  "Gene Therapy": { section: "mechanismsOfAction", keyword: "Gene therapy" }, // note keyword different casing than key
  Oncology: { section: "therapeuticAreaTags", keyword: "Oncology" },
  "Hospital In-Patient": { section: "otherAttributes", keyword: "Hospital In-Patient" },
  "Drug Complexity": { section: "isComplexMolecule", keyword: "Drug Complexity" },
};

export const REPORT_FILTERS = {
  "IPD's Clinical Pipeline Report": {
    section: "hasDrugPipelineReport",
    keyword: "IPD's Clinical Pipeline Report",
    hoverText:
      "This filter includes all products currently monitored by IPD’s team of clinical pharmacists. Detailed pharmacist commentary is available for many of these drugs.",
  },
  "IPD's High Impact Pipeline Report": {
    section: "hasHighImpactTag",
    keyword: "IPD's High Impact Pipeline Report",
    hoverText:
      "This filter includes select high-impact and important-to-watch products that appear in IPD's Pipeline Report, with insights from IPD’s team of clinical pharmacists.",
  },
};

export const SUBMISSION_TYPES_FILTERS = {};

export const MENU_AUTOCOMPLETES_TITLES = {
  brandName: "Brand Name",
  genericName: "Generic Name",
  brandCompanies: "Brand Company",
  therapeuticAreaTags: "Therapeutic Area",
  diseaseState: "Disease State",
  routesOfAdministration: "Route of Administration",
  mechanismsOfAction: "Mechanism of Action",
  complexForms: "Drug Complexity",
};
export const MENU_SECTION_TITLES: filter.MenuSectionTitles = {
  stages: "Stages",
  submissionTypes: "Submission Type",
  launchCharacteristics: "Launch Characteristics",
  drugCharacteristics: "Drug Characteristics",
  otherAttributes: "Other Attributes",
};

export const OPTIONS: filter.MenuSectionOptions = {
  drugCharacteristics: [
    "Brand Name",
    "Generic Name",
    "Brand Company",
    "Therapeutic Area",
    "Disease State",
    "Route of Administration",
    "Mechanism of Action",
    "Drug Complexity",
  ],
  drugTypes: ["Small Molecule Only", "Biologics Only"],
  fdaDesignations: ["Breakthrough Therapy", "Accelerated Approval", "Fast Track", "Priority Review"],
  otherAttributes: [
    "Biologics & Biosimilars",
    "Hospital In-Patient",
    "Medical Imaging Agents & Procedures",
    "Rare Disease",
    "Specialty (Professionally Administered)",
    "Specialty (Self-Administered)",
    "Vaccine",
  ],
  stages: [
    "Pre-Clinical",
    "Phase I",
    "Phase II",
    "Phase III",
    "Tentative Approval",
    "Upcoming PDUFA Date",
    "Withdrawn",
    "Complete Response Letter",
  ],
  submissionTypes: ["NDA", "BLA", "sNDA", "sBLA", "Biosimilar", "505(b)(2) NDA"],
  complexForms: [
    {
      name: "API",
      values: [
        "API: Characterization (Particle size requirement, Surface area, etc.)",
        "API: API sameness challenges",
        "API: Limited source/Manufacturing difficulty",
        "API: Genotoxic impurity",
        "API: Non-availability of stable polymorph",
      ],
    },
    {
      name: "Regulatory",
      values: [
        "Regulatory: BA/BE Study in specific population",
        "Regulatory: Clinical/PK endpoints study",
        "Regulatory: Q3 characterization",
        "Regulatory: BE studies required for all approved strengths",
        "Regulatory: Abuse-deterrent",
        "Regulatory: Narrow Therapeutic Index (NTI)",
        "Regulatory: Partial AUC/High Pharmacokinetic Variability",
      ],
    },
    {
      name: "Formulation",
      values: [
        "Formulation: Complex formulation/dosage form",
        "Formulation: Drug-Device combination",
        "Formulation: First-in-class formulation technology",
      ],
    },
  ],
};

export const MENU_SECTION_OPTIONS_LABELS = {
  drugTypes: "Small Molecule / Biologic",
  fdaDesignations: "FDA Designations",
  submissionTypes: "Submission Type",
  pdufa: "PDUFA Date Range",
  complexForms: "Drug Complexity",
};
